// 信息发布
const ContentManageNews = () => import('@/views/contentManage/news/index.vue') // 园区资讯
const ContentManageAnnouncement = () => import('@/views/contentManage/announcement/index.vue') // 园区公告
const ContentManageBanner = () => import('@/views/contentManage/banner/index.vue') // 轮播设置

export default {
  ContentManageNews,
  ContentManageAnnouncement,
  ContentManageBanner
}
